import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    paddingBottom: '48px',

    maxWidthTabletSm: {
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '16px',
      paddingBottom: '16px',
      borderTopWidth: '1px',
      borderTopStyle: 'solid',
      borderTopColor: colors.space15,
    },
  },
});

export default styles;
